import ContentHandler from 'owa-controls-content-handler/lib/schema/ContentHandler';
import {
    lazyTryProcessSharePointLink,
    lazyTryUndoProcessSharePointLink,
} from 'owa-doc-link-click-handler';
import { ClientItemId } from 'owa-client-ids';

export const SHAREPOINT_LINK_HANDLER_NAME = 'sharePointLinkHandler';
const SHAREPOINT_LINK_HANDLER_SELECTOR = 'a';

function processElement(itemId: ClientItemId): (element: HTMLElement, keyword: string) => void {
    return async (element: HTMLElement, keyword: string) => {
        const tryProcessSharePointLink = await lazyTryProcessSharePointLink.import();
        tryProcessSharePointLink(element, itemId);
    };
}

function undoProcessElements(elements: HTMLElement[]) {
    const tryUndoProcessSharePointLink = lazyTryUndoProcessSharePointLink.tryImportForRender();
    if (tryUndoProcessSharePointLink) {
        tryUndoProcessSharePointLink(elements);
    }
}

export default function getSharePointLinkHandler(itemId: ClientItemId): ContentHandler {
    return {
        cssSelector: SHAREPOINT_LINK_HANDLER_SELECTOR,
        keywords: null,
        handler: processElement(itemId),
        undoHandler: undoProcessElements,
    };
}
